<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useCurrentUser } from 'vuefire';
import { useDark } from '@vueuse/core'
import { createRoutes } from '../router.ts';

const router = useRouter();
const route = useRoute();
const user = useCurrentUser();
const prefersDarkMode = useDark()

const handleSignoutButton = (event: Event) => {
  event.preventDefault();
  router.push({
    name: 'signout',
    query: { redirect: route.fullPath }
  });
};

// only show signout button on pages that require auth
const isValidSignoutPage = computed(() =>
  createRoutes({ENABLE_ARTICLE_VIEWER:true})
    .filter(r => r?.meta?.requiresAuth)
    .map(r => r?.name)
    .includes(route.name)
);

const shouldShowSignoutButton = computed(() =>
  !!user?.value && isValidSignoutPage.value
);

</script>

<template>
  <nav :class="['navbar navbar-expand-lg w-100', prefersDarkMode ? 'navbar-dark' : 'navbar-light']">
    <div id="navbarNav" class="navbar-collapse">
      <ul class="navbar-nav ms-auto mx-3">
        <li class="nav-item">
          <button v-if="shouldShowSignoutButton" id="logout" @click="handleSignoutButton">
            Logout
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>
